import Backbone from "backbone";
import template from "./template.html";
import _ from "underscore";

import {date as dateutils} from "utils";

let FilterView = Backbone.View.extend({
    template,
    id: "floorplan-list-controls",
    events: {
        "submit": "submit",
        "change [type=checkbox]": "toggleCheckbox",
        "change #toggle-filters": "toggleFilters",
        "change #maxrent": "rentFilter",
        "change #unitnumber": "unitNumberFilter",
        "keyup #unitnumber": "unitNumberFilter",
        "focus .checklist-dropdown-inline-fp *": "showFocusedChecklist",
        "blur .checklist-dropdown-inline-fp *": "hideBlurredChecklist",
        "mouseover .checklist-dropdown-inline-fp": "showHoveredChecklist",
        "mouseout .checklist-dropdown-inline-fp *": "hideUnhoveredChecklist",
        "mouseover .date-inline-fp": "hideUnhoveredChecklist",
        "mouseover .maxrent-inline-fp": "hideUnhoveredChecklist",
        "mouseover .unit-number-inline-fp": "hideUnhoveredChecklist"
    },
    initialize: function(opts) {
        this.firstRun = true;
        this.useAdvancedFeaturesCheckbox = opts.useAdvancedFeaturesCheckbox || false;
        this.showFilters = opts.advancedFeaturesDefault || false;
        this.apartmentType = opts.apartmentType || "Apartment";
    },
    render: function() {
        if (this.firstRun) {
            let filter = this.collection.filter;
            let date = filter.getDateFilterValue();
            let checkLists = filter.getCheckboxFilter().serialize();
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let altDate = dateutils.format(today);
            if (date) {
                date = dateutils.format(date);
            }

            let includeDateFilter = true;
            let useAdvancedFeaturesCheckbox = this.useAdvancedFeaturesCheckbox;
            let showFilters = !useAdvancedFeaturesCheckbox || this.showFilters;
            let hideUnitNumbers = this.collection.getHideUnitNumbers();
            let apartmentType = this.apartmentType;

            let allDates = this.getAllDates();
            let min = _.min(allDates);
            if (!allDates.length) {
                includeDateFilter = false;
            } else if (min < today) {
                // If the lowest date is earlier than the current day,
                // tell the datepicker to use the current date as minimum value.
                min = true;
            }

            let context = {
                date,
                altDate,
                includeDateFilter,
                useAdvancedFeaturesCheckbox,
                showFilters,
                hideUnitNumbers,
                checkLists,
                apartmentType
            };

            this.$el.html(this.template(context));

            if (includeDateFilter) {
                this.$el.find("#movein_date").pickadate({
                    format: dateutils.formatString().toLowerCase(),
                    onSet: (e) => this.setDate(e),
                    min
                });
            }
            this.$el.find("#filter_container").toggleClass("in",
                !this.useAdvancedFeaturesCheckbox || this.showFilters);
            this.firstRun = false;
        }
        this.delegateEvents();
        return this;
    },
    rentFilter: function(e) {
        let elem = e.target;
        let value = parseFloat(elem.value);
        if (!value) {
            value = null;
        }
        this.collection.filterMaxRent(value);
    },
    unitNumberFilter: function(e) {
        this.collection.filterUnitNumber(e.target.value);
    },
    toggleCheckbox: function(e) {
        let elem = e.target;
        let listName = elem.getAttribute("data-list");
        let value = elem.value;

        if (elem.id != "toggle-filters") {
            this.collection.toggleFilterCheckbox(listName, value);
        }
    },
    toggleFilters: function(e) {
        e.preventDefault();
        this.showFilters = !this.showFilters;
        let toggleValue = !this.useAdvancedFeaturesCheckbox || this.showFilters;

        this.$el.find("#filter_container").toggleClass("in", toggleValue);
        this.$el.find(".filter-checkbox").toggleClass("filter-checkbox-open", toggleValue);
    },
    setDate: function(change) {
        let date = null;
        if (change.select) {
            date = new Date(change.select);
        }

        this.collection.filterDate(date);
    },
    submit: function(e) {
        e.preventDefault();
    },
    getAllDates: function() {
        // flatten collection and get all unit available dates
        let dates = [];
        let unitCollections = _.filter(this.collection.pluck("units"), (c) => c.length);
        let avails = _.invoke(unitCollections, "pluck", "available_date");
        // avails will be an array of arrays of dates. Flatten in into dates array.
        _.each(avails, (dateArr) => dates = dates.concat(dateArr));

        return dates;
    },
    showFocusedChecklist: function(e) {
        let elem = e.target;

        this.$(this.getChecklistParent(elem)).addClass("open");
    },
    hideBlurredChecklist: function(e) {
        let element = e.target;
        let self = this;

        (function(elem) {
            setTimeout(function() {
                // We have to do this bit concurrently so the browser has time to update document.activeElement.
                let parent = self.getChecklistParent(elem);

                if (!parent.contains(document.activeElement)) {
                    self.$(parent).removeClass("open");
                }
            }, 0);
        }(element));
    },
    showHoveredChecklist: function(e) {
        let elem = e.target;
        let $parent = this.$(this.getChecklistParent(elem));

        $parent.addClass("open");
        this.$el.find(".checklist-dropdown-inline-fp").not($parent).removeClass("open");
    },
    hideUnhoveredChecklist: function(e) {
        let elem = e.target;
        let parent = this.getChecklistParent(elem);

        if (!parent) {
            this.$el.find(".checklist-dropdown-inline-fp").removeClass("open");
        } else if (!parent.contains(e.relatedTarget)) {
            this.$(parent).removeClass("open");
        } else if (parent == e.relatedTarget) {
            this.$(parent).removeClass("open");
        }
    },
    getChecklistParent: function(elem) {
        let parent = null;

        while (elem && elem.parentNode !== document.body) {
            if (elem.className && elem.className.indexOf("checklist-dropdown-inline-fp") !== -1) {
                parent = elem;
                break;
            }
            elem = elem.parentNode;
        }

        return parent;
    }
});

export {FilterView};
